jQuery(function ($) {
  if (jQuery('.search.search-results').length) {
    let posts = ['articles', 'formations', 'ressources'];
    posts.forEach((element) => {
      if (jQuery('#' + element)[0].childElementCount > 0) {
        jQuery('#message-' + element).css('font-weight', 'bold');
        jQuery('#message-' + element).text(
          'Votre résultat de recherche dans nos ' + element + ' :'
        );
      } else {
        jQuery('#' + element).css('margin', 0);
        jQuery('#message-' + element).text(
          'Aucun résultat de recherche dans nos ' + element
        );
      }
    });
  }
});
